<template>
	<dialog-generic :visibility.sync = 'visibility' :indicator = 'indicator'>
        <template v-slot:title>{{project.project_name}}</template>
        <template v-slot:content>
            <div class = 'py-3' v-if = 'archive'>{{project.active? "Архивировать":"Деархивировать"}} проект?</div>
	        <div class = 'py-3' v-else>Удалить проект?</div>
        </template>
        <template v-slot:action>
            <v-btn class = 'px-0 red--text text--darken-2' :loading = 'indicator' block depressed @click = 'confirmDeleteOrArchive'>
				{{ archive ? (project.active? "Архивировать":"Деархивировать"):"Удалить" }}
			</v-btn>
        </template>
    </dialog-generic>
</template>

<script>
	import DialogGeneric from '@/components/elements/dialogs/Generic.vue'
	import projectHandlers from '@/mixins/project'

	export default {
		name: 'ProjectDeleteDialog',
		props: ['data', 'initialState', 'archive'],
		components: {'dialog-generic': DialogGeneric},
		mixins: [projectHandlers],
		data() {
			return {
				visibility: this.initialState,
				indicator: false,
				project: this.data
			}
		},
		watch: {
	        initialState(value) {
	            this.visibility = value;
		    },
		    visibility(value) {
		       	this.$root.$emit('projectDeleteDialogVisibility', value);
		    }
	    },
		methods: {
			confirmDeleteOrArchive() {
				if (this.archive) {
					this.archiveProject()
				} else {
					this.deleteProject()
				}
			},
			archiveProject() {
				this.indicator = true;
				this.project.active = this.project.active == 1? 0: 1;
				this.updateProjectPromise().then((r) => {
	                this.visibility = false;
					this.indicator = false;
					let goToMain = () => {
						this.$router.push('/')
					}
					this.$dataLayer.$emit('enrich', {
                        event: 'crud',
                        data: {
                            type: 'archive',
                            target: 'project'
                        },
                        once: false
                    })
					this.$store.dispatch('getObjects', goToMain)
	            });
			},
			deleteProject() {
				this.indicator = true;
				this.deleteProjectPromise().then( (r) => {
		        	this.visibility = false;
					this.indicator = false;
					let goToMain = () => {
						this.$router.push('/')
					}
					this.$dataLayer.$emit('enrich', {
                        event: 'crud',
                        data: {
                            type: 'delete',
                            target: 'project'
                        },
                        once: false
                    })
					this.$store.dispatch('getObjects', goToMain)
		        });
			}
		}
	}
</script>